'use client';

/* eslint-disable i18n/no-russian-character */
import * as SliderPrimitive from '@radix-ui/react-slider';

import { styles } from './UiKitSliderBase.styles';

export interface UiKitSliderBaseProps {
  value: [number, number];
  onChange: (value: [number, number]) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  labelFrom?: string;
  labelTo?: string;
}

export function UiKitSliderBase({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled,
  labelFrom,
  labelTo,
  ...props
}: UiKitSliderBaseProps) {
  const slots = styles({ disabled });

  return (
    <div className={slots.base()}>
      <div className={slots.labels()}>
        <span className={slots.label()}>{labelFrom ?? value[0]}</span>
        <span className={slots.label()}>{labelTo ?? value[1]}</span>
      </div>
      <SliderPrimitive.Root
        className={slots.sliderRoot()}
        value={value}
        onValueChange={onChange}
        onPointerDown={(e) => e.stopPropagation()}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        {...props}
      >
        <SliderPrimitive.Track className={slots.track()}>
          <SliderPrimitive.Range className={slots.range()} />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          className={slots.thumb()}
          aria-label="Минимальное значение"
        >
          <span className={slots.thumbCircle()} />
        </SliderPrimitive.Thumb>
        <SliderPrimitive.Thumb
          className={slots.thumb()}
          aria-label="Максимальное значение"
        >
          <span className={slots.thumbCircle()} />
        </SliderPrimitive.Thumb>
      </SliderPrimitive.Root>
    </div>
  );
}
